import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { ISimplifiedReport } from "../interface/report/ISimplifiedReport";
import { ICompletedReport } from "../interface/report/ICompletedReprort";
import { IConsorcieiReport } from "../interface/report/IConsorcieiReport";

enum DashboardReportServiceEnum {
  phases = "/phases",
  phasesV2Completed = '/v2/completed',
  phasesV2CompletedNoDatetime = '/v2/completed/nodatetime',
  phasesV2Simplified = '/v2/simplified',
  panContracts = '/pan/contracts',
  consorcieiReport = '/consorciei',
}

export default class DashboardReportService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/dashboard");
  }

  public getPhasesReport = async () => await this.GET(DashboardReportServiceEnum.phases);
  public getCompletedPhasesReport = async (): Promise<ICompletedReport[]> => await this.GET(DashboardReportServiceEnum.phasesV2Completed);
  public getCompletedNoDatetiemPhasesReport = async (): Promise<ICompletedReport[]> => await this.GET(DashboardReportServiceEnum.phasesV2CompletedNoDatetime);
  public getSimplifiedPhasesReport = async (): Promise<ISimplifiedReport[]> => await this.GET(DashboardReportServiceEnum.phasesV2Simplified);
  public getPanContracts = async (): Promise<IPanContractsReport[]> => await this.GET(DashboardReportServiceEnum.panContracts);
  public getConsorcieiReport = async (): Promise<IConsorcieiReport[]> => await this.GET(DashboardReportServiceEnum.consorcieiReport);
}



// WEBPACK FOOTER //
// ./src/services/api/DashboardReport.service.ts